export default __webpack_public_path__ + "static/media/cover.3101b047.png";